export var MarkMessagesAsEnum;
(function (MarkMessagesAsEnum) {
    MarkMessagesAsEnum["READ"] = "read";
    MarkMessagesAsEnum["SEEN"] = "seen";
    MarkMessagesAsEnum["UNREAD"] = "unread";
    MarkMessagesAsEnum["UNSEEN"] = "unseen";
})(MarkMessagesAsEnum || (MarkMessagesAsEnum = {}));
